// ABOUTME: Date picker form field with label
// ABOUTME: Wrapper around CDatePicker for form usage

import { CLabel } from "./CLabel"
import { CDatePicker, type CDatePickerProps } from "./CDatePicker"

type DatePickerFieldProps = CDatePickerProps & {
  label: string
}

export const DatePickerField = (props: DatePickerFieldProps) => {
  const { className, label, ...datePickerProps } = props

  return (
    <div className={className}>
      {/* Focus trap workaround for calendar */}
      <input
        type="search"
        className="w-[0px] h-[0px] opacity-100 border-none absolute left-[-9999px]"
      />

      {label && <CLabel className="block mb-1 text-sm font-medium text-gray-900">{label}</CLabel>}
      <CDatePicker {...datePickerProps} />
    </div>
  )
}
